<template>
  <RouterView v-slot="{ Component }">
    <component :is="Component" v-if="Component" />
    <div v-else class="app-shell-loader" role="status" aria-live="polite" aria-label="正在加载森灵">
      <div class="app-shell-loader__content">
        <p class="app-shell-loader__title">正在进入森灵</p>
        <div class="app-shell-loader__progress" aria-hidden="true"></div>
      </div>
    </div>
  </RouterView>
</template>

<script setup>
import { RouterView } from "vue-router";

// 设置暗色主题
document.documentElement.classList.add('dark');
document.documentElement.setAttribute('data-theme', 'dark');
</script>

<style>
html,
body {
  margin: 0;
  padding: 0;
  height: 100%;
  background-color: #0B0B0B; /* 暗色背景 */
  color: #ffffff; /* 暗色文字 */
}
</style>
